import { getDB } from "@/db";
import { LOCALSTORAGE_KEY } from "./constants";

export const emptyStorageUser = async () => {
  const db = await getDB();
  await db.clear("appState");
  await db.clear("elements");
  localStorage.removeItem(`${LOCALSTORAGE_KEY}_IMAGES`);
  localStorage.removeItem(`${LOCALSTORAGE_KEY}_WALLPAPER_STORE`);
  localStorage.removeItem("unideck.auth.accessToken");
  localStorage.removeItem("unideck.auth.dismissed");
  localStorage.removeItem("unideck.activeProfileId");
};
